/**
 * Creates a configuration for styled components to prevent passing certain props forward
 *  See also https://github.com/styled-./components/styled-./components/releases/tag/v5.1.0
 */
const makeExcludePropsConfig = (propNames: string[]) => ({
  shouldForwardProp: (s: unknown) => !propNames.includes(s as any),
})

export default makeExcludePropsConfig
